export default __webpack_public_path__ + "static/media/jumanji.ce16779d.png";